import { render, staticRenderFns } from "./default.vue?vue&type=template&id=a8e0fca8"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"
import style0 from "./default.vue?vue&type=style&index=0&id=a8e0fca8&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VerticalNav: require('/home/runner/work/lms-admin/lms-admin/components/verticalNav.vue').default,HeaderComponent: require('/home/runner/work/lms-admin/lms-admin/components/headerComponent.vue').default})
